import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="hamburger" onClick={toggleMenu}>
        <div className={`bar ${isOpen ? 'open' : ''}`}></div>
        <div className={`bar ${isOpen ? 'open' : ''}`}></div>
        <div className={`bar ${isOpen ? 'open' : ''}`}></div>
      </div>
      <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
        <li><Link to="/" onClick={() => setIsOpen(false)}>Home</Link></li>
        <li><Link to="/music" onClick={() => setIsOpen(false)}>Music</Link></li>
        <li><Link to="/videos" onClick={() => setIsOpen(false)}>Videos</Link></li>
        <li><Link to="/pix" onClick={() => setIsOpen(false)}>Pix</Link></li>
        <li><Link to="/epk" onClick={() => setIsOpen(false)}>EPK</Link></li>
        <li><Link to="/info" onClick={() => setIsOpen(false)}>Info</Link></li>
        <li><Link to="/shows" onClick={() => setIsOpen(false)}>Shows</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;